import { AnswerRepository } from "../../../../data/repository/answer/AnswerRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteAnswerAttachmentUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteAnswerAttachmentUseCaseImpl implements DeleteAnswerAttachmentUseCase {
  private repo: AnswerRepository;

  constructor(repo: AnswerRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.deleteAnswerAttachment(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
